import styled from 'styled-components'
import { colors } from '../../../styles'

export const StyledOrderTable = styled.table`
  min-width: 75%;
  max-width: 100%;
  tr {
    padding: 8px 8px;
    display: grid;
    grid-template-columns: 0.4fr 3fr 3fr 1fr 1fr;
  }
  td,
  th {
    word-break: break-word;
    text-align: left;
  }
  td {
    display: flex;
    align-items: center;
  }
`
export const StyledRow = styled.tr`
  z-index: 32;
  padding: 12px 8px;
  display: grid;
  grid-template-columns: 0.4fr 3fr 3fr 1fr 1fr;

  &:hover {
    background-color: ${colors.orange10};
  }

  & .drag-handler {
    cursor: grab;
    svg {
      color: ${colors.grey40};
    }
  }

  &.media-type-list-sorted-item {
    cursor: grabbing;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }
`
